import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { Logo } from "@/components/Logo";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-screen bg-[#07080E] text-slate-200 flex flex-col items-center justify-center px-6 text-center">
      <Seo title="Page not found (404)" description="The page you requested does not exist on Vectra." noindex />
      <Logo />
      <h1 className="mt-10 text-4xl sm:text-5xl font-semibold tracking-tight">404 — page not found</h1>
      <p className="mt-4 text-sm sm:text-base text-slate-400 max-w-md">This address does not exist. Check the URL or head back to a real page.</p>
      <div className="mt-8 flex flex-wrap gap-3 justify-center text-sm">
        <Link data-testid="not-found-home" to="/" className="px-4 py-2 rounded-full bg-cyan-500 text-black font-medium">Home</Link>
        <Link data-testid="not-found-pricing" to="/pricing" className="px-4 py-2 rounded-full border border-white/15 hover:border-cyan-400/50">Pricing</Link>
        <Link data-testid="not-found-contact" to="/contact" className="px-4 py-2 rounded-full border border-white/15 hover:border-cyan-400/50">Contact</Link>
      </div>
    </div>
  );
}
